var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('iframe',{attrs:{"src":"http://www.hightopo.com/demo/qiandaogui/","frameborder":"0","height":"100%"}})])
}]

export { render, staticRenderFns }